<template>
  <div class="flex w-full items-center space-x-3 px-4 py-2">
    <FreeBackButton @click="emit('onReturnButtonClick')" />
    <div
      class="border-situational-lightgrey flex min-w-0 flex-1 items-center gap-2 rounded-2xl border px-3 py-1.5"
    >
      <div class="flex min-w-0 flex-1 flex-col items-start">
        <div
          class="shimmer bg-background-neutral-tertiary h-[16px] w-[140px] rounded-2xl"
        ></div>
        <div
          class="shimmer bg-background-neutral-tertiary mt-2 h-[14px] w-[110px] rounded-2xl"
        ></div>
      </div>
      <div
        class="shimmer bg-background-neutral-tertiary h-6 w-6 rounded-full"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { FreeBackButton } from 'freedom-shared';

  const emit = defineEmits<{
    onReturnButtonClick: [];
  }>();
</script>
